<div class="wrapper margin-top">
  <tabs (tabClicked)="onTabClicked()">
    <tab title="Program Areas">
      <div class="grid-container margin-top">
        <div class="bold">
          <h4>Add A Program Area:</h4>
        </div>
        <div class="grid-x">
          <div class="cell large-10 select-lines">
            <div class="bold">
              New Program Area Name:
            </div>
            <div class="">
              <label class="inline">
                <input type="text" [(ngModel)]="newProgramAreaName">
              </label>
            </div>
          </div>
          <div class="cell large-12 select-lines  margin-right">
            <button class="button hollow minor-margin-right" [attr.disabled]="canAddProgramArea() && programAreaUnderMaximumLength() ? null : 'disabled'" (click)="addProgramArea()">Add Program Area</button>
            @if (!canAddProgramArea()) {
              <div class="error-container">
                @if (!canAddProgramArea()) {
                  <small class="error">
                    Please enter a name that isn't already used by an existing Program Area.
                  </small>
                }
              </div>
            }
            @if (!programAreaUnderMaximumLength()) {
              <div class="error-container">
                <small class="error">
                  Please enter a program area name that is no more than {{programAreaKeyword?.dataLength}} characters in length.
                </small>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="bold">
        <h4>View / Edit Existing Program Areas:</h4>
      </div>
      @if (programAreaHasBeenSelected()) {
        <div class="grid-x">
          <div class="cell large-10 select-lines">
            <div class="bold">
              Edited Program Area Name:
            </div>
            <div class="">
              <label class="inline">
                <input type="text" [disabled]="programAreaHasBeenSelected() ? null : 'disabled'" [(ngModel)]="currentlySelectedGridProgramArea.name">
              </label>
            </div>
          </div>
          <div class="cell large-12 select-lines margin-right">
            <onbase-program-area-document-group-permission-selector [group-title]="'Program Area Document Groups'" [selected-title]="'Selected Document Groups'" [available-title]="'Available Document Groups'" [elements]="documentGroups" [initial-set]="selectedDocumentGroupsForProgramArea" (changed)="updateProgramAreaDocumentGroups($event)">
            </onbase-program-area-document-group-permission-selector>
          </div>
          <div class="cell large-12 select-lines  margin-right">
            <button class="button hollow minor-margin-right" [attr.disabled]="canUpdateProgramArea() && programAreaUnderMaximumLength() ? null : 'disabled'" (click)="updateProgramArea()">Save Updated Program Area</button>
            @if (!canUpdateProgramArea()) {
              <div class="error-container">
                @if (!canUpdateProgramArea()) {
                  <small class="error">
                    Please enter a name that isn't empty, or already used by an existing Program Area.
                  </small>
                }
              </div>
            }
            @if (!programAreaUnderMaximumLength()) {
              <div class="error-container">
                <small class="error">
                  Please enter a program area name that is no more than {{programAreaKeyword?.dataLength}} characters in length.
                </small>
              </div>
            }
          </div>
        </div>
      }
      <div class="grid-x">
        <div class="cell large-12 medium-12 small-12">
          <ag-grid-angular class="data-grid " [gridOptions]="programAreaGridOptions" [rowData]="programAreas" aria-label="Program Areas"></ag-grid-angular>
        </div>
      </div>
 
      <div class="bold">
        <h4>Import Base Document Group -> Document Type -> Associated Keywords:</h4>
      </div>
      <div class="grid-x">
        This might take a while:
        <button class="button hollow minor-margin-right" (click)="importFromOnBase()">Import OnBase Mappings</button>
      </div>
      <!--<div class="grid-x grid-margin-x">
      <div class="cell large-12 medium-12 small-12 bold">
        Update OnBase Mappings
      </div>
      <div class="cell large-6 medium-6 small-6">
        1.  Load Latest Mappings from OnBase: <button [disabled]="onBaseGroupsStatus == 'Loading...'" (click)="loadOnBaseGroups()" class="button">Load</button>
      </div>
      <div class="cell large-6 medium-6 small-6">
        {{onBaseGroupsStatus}}
      </div>
      <div class="cell large-6 medium-6 small-6">
        2.  Process Groups:  <button (click)="processOnBaseGroups()" [disabled]="onBaseGroupsStatus != 'Complete' || onBaseGroups?.length == 0 || (processingResults.length > 0 && processingResults.length < onBaseGroups.length)" class="button">Process</button>
      </div>
      <div class="cell large-6 medium-6 small-6">
        Processed {{processingResults.length}} groups of {{onBaseGroups.length}} total groups.
      </div>
      <div class="cell large-12 medium-12 small-12">
        {{deletedGroupsMessage}} {{processingStatus}}
      </div>
      <div class="cell large-12 medium-12 small-12" *ngFor="let result of processingResults">
        {{result}}
      </div>
    </div>-->
  </tab>
</tabs>
</div>
